module.exports = __webpack_public_path__ + "img/living_2_tn.bbfff2dd.jpg";